import { ApplicationState } from '@app/store'
import {
  actionCreators,
  IAccountState,
  selectAccessToken,
  selectCurrentUser,
  selectIsInitialized,
  selectPreferences,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import SecureRoute from '../components/SecureRoute'

export default connect(
  createStructuredSelector<ApplicationState, IAccountState>({
    accessToken: selectAccessToken(),
    isInitialized: selectIsInitialized(),
    preferences: selectPreferences(),
    user: selectCurrentUser(),
  }),
  actionCreators,
)(SecureRoute)
